import { render } from "./SearchCompanyModal.vue?vue&type=template&id=ca4027d4&scoped=true"
import script from "./SearchCompanyModal.vue?vue&type=script&lang=js"
export * from "./SearchCompanyModal.vue?vue&type=script&lang=js"

import "./SearchCompanyModal.vue?vue&type=style&index=0&id=ca4027d4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4027d4"]])

export default __exports__